function getItem(key) {
  return localStorage.getItem(key)
}

function setItem(key, value) {
  localStorage.setItem(key, value)
}

function removeItem(key) {
  localStorage.removeItem(key)
}

const TB_APP_LANG = 'TB_APP_LANG'

export function getLang() {
  return getItem(TB_APP_LANG)
}

export function setLang(lang) {
  setItem(TB_APP_LANG, lang)
}

export function removeLang() {
  removeItem(TB_APP_LANG)
}



// WEBPACK FOOTER //
// ./src/utils/languages.js